"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("../utils");
var _configProvider = require("../config-provider/configProvider");
var _calculateNodeHeight = _interopRequireDefault(require("./calculateNodeHeight"));
var _useLocale3 = _interopRequireDefault(require("../locale/useLocale"));
var _utils2 = _interopRequireDefault(require("../locale/utils"));
var _icon = _interopRequireDefault(require("../icon"));
var _resizeObserver = _interopRequireDefault(require("../utils/dom/resizeObserver"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * 在下一帧执行回调函数
 * @param cb 要执行的回调函数
 * @returns 返回requestAnimationFrame或setTimeout的标识符
 */
function onNextFrame(cb) {
  if (window.requestAnimationFrame) {
    return window.requestAnimationFrame(cb);
  }
  return window.setTimeout(cb, 1);
}
/**
 * 取消标识符 nextFrameId 的回调函数
 * @param nextFrameId requestAnimationFrame或setTimeout的标识符
 */
function clearNextFrameAction(nextFrameId) {
  if (window.cancelAnimationFrame) {
    window.cancelAnimationFrame(nextFrameId);
  } else {
    window.clearTimeout(nextFrameId);
  }
}
// TextArea组件的主体实现
var TextArea = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _props$value, _value$length;
  var _useContext = (0, _react.useContext)(_configProvider.ConfigContext),
    getPrefixCls = _useContext.getPrefixCls;
  var textareaRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)((_props$value = props.value) !== null && _props$value !== void 0 ? _props$value : ''),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useState3 = (0, _react.useState)({}),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    textareaStyles = _useState4[0],
    setTextareaStyles = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    isClearVisible = _useState6[0],
    setIsClearVisible = _useState6[1];
  var clearIconRef = (0, _react.useRef)(null);
  // 仅用于处理 maxLength的场景：当超出maxLength时，依赖该值来截取文字长度，防止超出
  var isComposing = (0, _react.useRef)(false);
  var nextFrameActionId = (0, _react.useRef)(null);
  var prefixCls = getPrefixCls('input');
  var size = props.size,
    className = props.className,
    _props$showCount = props.showCount,
    showCount = _props$showCount === void 0 ? false : _props$showCount,
    _props$countPosition = props.countPosition,
    countPosition = _props$countPosition === void 0 ? 'outer' : _props$countPosition,
    onChange = props.onChange,
    onPressEnter = props.onPressEnter,
    onKeyDown = props.onKeyDown,
    onBlur = props.onBlur,
    onFocus = props.onFocus,
    _props$dispatchChange = props.dispatchChange,
    dispatchChange = _props$dispatchChange === void 0 ? ['onInput'] : _props$dispatchChange,
    onInput = props.onInput,
    _props$maxLength = props.maxLength,
    maxLength = _props$maxLength === void 0 ? Infinity : _props$maxLength,
    style = props.style,
    _props$autosize = props.autosize,
    autosize = _props$autosize === void 0 ? true : _props$autosize,
    status = props.status,
    _props$isTruncation = props.isTruncation,
    isTruncation = _props$isTruncation === void 0 ? true : _props$isTruncation,
    _props$clearable = props.clearable,
    clearable = _props$clearable === void 0 ? false : _props$clearable;
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    isEditing = _useState8[0],
    setIsEditing = _useState8[1];
  // 监听value变化，更新内部状态
  (0, _react.useEffect)(function () {
    if ('value' in props && props.value !== value) {
      var _dispatchChange$inclu;
      var update = false;
      if (dispatchChange !== null && dispatchChange !== void 0 && (_dispatchChange$inclu = dispatchChange.includes) !== null && _dispatchChange$inclu !== void 0 && _dispatchChange$inclu.call(dispatchChange, 'onInput')) {
        update = true;
      } else if (!isEditing) {
        // 适用于dispatchChange中仅包含onBlur的场景
        update = true;
      }
      if (update) {
        var _props$value2;
        setValue((_props$value2 = props.value) !== null && _props$value2 !== void 0 ? _props$value2 : '');
      }
    }
  }, [props.value, value, isEditing]);
  // 监听value和autosize变化，重新计算textarea高度
  (0, _react.useEffect)(function () {
    if (nextFrameActionId.current) {
      clearNextFrameAction(nextFrameActionId.current);
    }
    // 重新计算高度
    nextFrameActionId.current = onNextFrame(resizeTextarea);
  }, [value, autosize]);
  // 在组件卸载时清理防抖
  (0, _react.useEffect)(function () {
    return function () {
      debouncedResizeTextarea.cancel();
    };
  }, []);
  /**
   * 获取输入框的className
   * @returns 输入框的className字符串
   */
  var getInputClassName = function getInputClassName() {
    return (0, _classnames.default)(className, prefixCls, "".concat(prefixCls, "-textarea"), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-sm"), size === 'small'), "".concat(prefixCls, "-lg"), size === 'large'), "".concat(prefixCls, "-textarea-countable"), showCount), "".concat(prefixCls, "-textarea-countable-").concat(countPosition), showCount), "".concat(prefixCls, "-status-").concat(status), status !== null && status !== void 0 ? status : false), "".concat(prefixCls, "-textarea-disabled"), props.disabled), "".concat(prefixCls, "-textarea-clearable"), clearable && value && isClearVisible));
  };
  /**
   * 获取字数统计的className
   * @returns 字数统计的className字符串
   */
  var getShowCountClassName = function getShowCountClassName() {
    return (0, _classnames.default)("".concat(prefixCls, "-textarea-count-").concat(countPosition), "".concat(prefixCls, "-textarea-count"));
  };
  // 暴露组件方法给父组件
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      blur: function blur() {
        textareaRef.current.blur();
      },
      focus: function focus() {
        textareaRef.current.focus();
      },
      textareaRef: textareaRef
    };
  });
  /**
   * 处理输入变化
   * @param e 输入事件
   */
  var handleChange = function handleChange(e) {
    var newValue = e.target.value;
    if (onChange && newValue !== props.value) {
      onChange(e);
    }
    setValue(newValue);
  };
  /**
   * 处理键盘按下事件
   * @param e 键盘事件
   */
  var handleKeyDown = function handleKeyDown(e) {
    if (e.keyCode === 13) {
      onPressEnter === null || onPressEnter === void 0 || onPressEnter(e);
    }
    onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
  };
  /**
   * 处理失焦事件
   * @param e 失焦事件
   */
  var handleBlur = function handleBlur(e) {
    var _dispatchChange$inclu2;
    var relatedTarget = e.relatedTarget;
    // 如果失焦时鼠标在清除按钮上，不隐藏清除按钮
    if (clearIconRef.current && clearIconRef.current.contains(relatedTarget)) {
      return;
    }
    setIsClearVisible(false);
    setIsEditing(false);
    if (dispatchChange !== null && dispatchChange !== void 0 && (_dispatchChange$inclu2 = dispatchChange.includes) !== null && _dispatchChange$inclu2 !== void 0 && _dispatchChange$inclu2.call(dispatchChange, 'onBlur')) {
      handleChange(e);
    }
    onBlur === null || onBlur === void 0 || onBlur(e);
  };
  /**
   * 处理聚焦事件
   * @param e 聚焦事件
   */
  var handleFocus = function handleFocus(e) {
    setIsEditing(true);
    setIsClearVisible(true);
    onFocus === null || onFocus === void 0 || onFocus(e);
  };
  /**
   * 处理输入事件
   * @param e 输入事件
   */
  var handleInput = function handleInput(e) {
    var _dispatchChange$inclu3;
    if (dispatchChange !== null && dispatchChange !== void 0 && (_dispatchChange$inclu3 = dispatchChange.includes) !== null && _dispatchChange$inclu3 !== void 0 && _dispatchChange$inclu3.call(dispatchChange, 'onInput')) {
      handleChange(e);
    } else {
      setValue(e.target.value);
    }
    // @ts-ignore
    onInput === null || onInput === void 0 || onInput(e);
  };
  /**
   * 重新计算textarea高度
   */
  var resizeTextarea = function resizeTextarea() {
    if (!autosize || !textareaRef.current) {
      return;
    }
    if ((0, _utils.isBoolean)(autosize)) {
      setTextareaStyles((0, _calculateNodeHeight.default)(textareaRef.current, false));
    } else {
      var minRows = autosize ? autosize.minRows : null;
      var maxRows = autosize ? autosize.maxRows : null;
      setTextareaStyles(_objectSpread(_objectSpread({}, (0, _calculateNodeHeight.default)(textareaRef.current, false, minRows, maxRows)), {}, {
        resize: 'none'
      }));
    }
  };
  // 包装resizeTextarea方法，添加防抖处理
  var debouncedResizeTextarea = (0, _utils.debounce)(resizeTextarea, 100); // 设置100ms的防抖时间
  /**
   * 处理输入法开始事件
   */
  var handleCompositionStart = function handleCompositionStart() {
    if (maxLength !== Infinity) {
      isComposing.current = true;
    }
  };
  /**
   * 处理输入法结束事件
   * @param e 输入法事件
   */
  var handleCompositionEnd = function handleCompositionEnd(e) {
    if (isComposing.current && maxLength !== Infinity) {
      var _dispatchChange$inclu4;
      isComposing.current = false;
      if (dispatchChange !== null && dispatchChange !== void 0 && (_dispatchChange$inclu4 = dispatchChange.includes) !== null && _dispatchChange$inclu4 !== void 0 && _dispatchChange$inclu4.call(dispatchChange, 'onInput')) {
        // @ts-ignore
        handleInput(e);
      }
    }
  };
  /**
   * 处理清空输入框
   */
  var handleClear = function handleClear() {
    setValue('');
    onChange === null || onChange === void 0 || onChange({
      target: {
        value: ''
      }
    });
  };
  var _useLocale = (0, _useLocale3.default)('textarea'),
    _useLocale2 = (0, _slicedToArray2.default)(_useLocale, 1),
    locale = _useLocale2[0];
  var _setLocale = (0, _utils2.default)(locale),
    t = _setLocale.t;
  /**
   * 渲染字数统计提示
   * @returns 字数统计提示节点
   */
  var renderTips = function renderTips() {
    if (showCount && maxLength !== Infinity) {
      if (valueLength > maxLength) {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
          className: "".concat(prefixCls, "-textarea-count-exceed")
        }, valueLength), /*#__PURE__*/_react.default.createElement("span", null, "/", maxLength));
      }
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, valueLength, "/", maxLength);
    }
    if (showCount) {
      // 国际化
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, t('showCount', {
        showCount: valueLength
      }));
    }
    return null;
  };
  /**
   * 处理鼠标进入事件
   */
  var handleMouseEnter = function handleMouseEnter() {
    if (clearable && value) {
      setIsClearVisible(true);
    }
  };
  /**
   * 处理鼠标离开事件
   */
  var handleMouseLeave = function handleMouseLeave(e) {
    var relatedTarget = e.relatedTarget;
    // 如果失焦时鼠标在清除按钮上，不隐藏清除按钮
    if (clearIconRef.current && clearIconRef.current.contains(relatedTarget) || isEditing) {
      return;
    }
    setIsClearVisible(false);
  };
  var valueLength = (_value$length = value === null || value === void 0 ? void 0 : value.length) !== null && _value$length !== void 0 ? _value$length : 0;
  var otherProps = (0, _utils.dropProps)(props, ['autosize', 'onPressEnter', 'dispatchChange', 'showCount', 'className', 'countPosition', 'isTruncation',
  // @ts-ignore
  'hasFeedback']);
  if (!isTruncation) {
    delete otherProps.maxLength;
  }
  var tipsNode = renderTips();
  return /*#__PURE__*/_react.default.createElement(_resizeObserver.default, {
    onResize: debouncedResizeTextarea
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: getInputClassName(),
    style: _objectSpread({}, style)
  }, /*#__PURE__*/_react.default.createElement("textarea", _objectSpread(_objectSpread({}, otherProps), {}, {
    value: value,
    style: textareaStyles,
    ref: textareaRef,
    onChange: handleInput,
    onCompositionStart: handleCompositionStart,
    onCompositionEnd: handleCompositionEnd,
    onBlur: handleBlur,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  })), showCount && tipsNode && ( /*#__PURE__*/_react.default.createElement("span", {
    className: getShowCountClassName()
  }, /*#__PURE__*/_react.default.createElement("i", null, tipsNode))), clearable && value && isClearVisible && /*#__PURE__*/_react.default.createElement("div", {
    ref: clearIconRef
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    className: "".concat(prefixCls, "-textarea-clear"),
    onClick: handleClear,
    type: "error-circle"
  }))));
});
TextArea.displayName = 'TextArea';
var _default = exports.default = TextArea;